// src/pages/Cart.tsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CartItem } from '../components/CartItem';
import { useCart } from '../contexts/CartContext';
import { usePageScroll } from '../hooks/usePageScroll';

export const Cart: React.FC = () => {
    usePageScroll('cart');

    const navigate = useNavigate();
    const {
        cartItems,
        loading,
        updateQuantity,
        removeFromCart,
        totalAmount,
        totalItems,
    } = useCart();

    // Спиннер только при первичной загрузке, когда ещё нет данных
    if (loading && cartItems.length === 0) {
        return (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Загрузка корзины...</p>
            </div>
        );
    }

    if (cartItems.length === 0) {
        return (
            <div className="container">
                <div className="empty-state">
                    <div className="empty-state-icon">🛒</div>
                    <h3>Корзина пуста</h3>
                    <p>Добавьте товары в корзину, чтобы оформить заказ</p>
                    <Link to="/products" className="auth-button">
                        Перейти в каталог
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <h1 className="page-title">Корзина</h1>

            <div className="cart-container">
                <div className="cart-items">
                    {cartItems.map((item) => (
                        <CartItem
                            key={item.id}
                            item={item}
                            onUpdateQuantity={updateQuantity}
                            onRemove={removeFromCart}
                        />
                    ))}
                </div>

                <div className="cart-summary">
                    <h3>Итого</h3>
                    <div className="summary-row">
                        <span>Товаров ({totalItems} шт.):</span>
                        <span>{totalAmount.toLocaleString()} TJS</span>
                    </div>
                    <div className="summary-total">
                        <span>Итого:</span>
                        <span>{totalAmount.toLocaleString()} TJS</span>
                    </div>
                    <button
                        onClick={() => navigate('/checkout')}
                        className="checkout-btn"
                    >
                        Перейти к оформлению
                    </button>
                </div>
            </div>
        </div>
    );
};